module.exports = function (resolve, reject) {
  var modal = INKIVE.Modal.modalWindow(
    INKIVE.TemplatesHelper('alert_span', {
      text: INKIVE.TranslateHelper.translate('modal.alert.draft')
    }),
    {
      width: 600,
      headerIcon: 'icon-news',
      headerTitle: 'modal.title.draft_template',
      closeCallback: reject,
      buttons: [{
        title: INKIVE.TranslateHelper.translate('modal.buttons.remove_draft'),
        onClick: function () {
          modal.close();
          resolve();
        }
      }, {
        title: INKIVE.TranslateHelper.translate('modal.buttons.keep_draft'),
        onClick: function () {
          modal.close();
          reject({close: true});
        }
      }]
    }
  );
};
